import {
  AutoParticularesIcon, SaudeParticularesIcon,
  AcidentesPessoaisIcon, WorkAccidentIcon,
  HousekeeperIcon, MultiRiscosHabitacaoIcon,
  VidaCreditoHabitacaoIcon, VidaProtecaoIcon,
  PetsIcon, QuestionIcon
} from "../../../utils/SVG";


export const insuranceOptions = [
  {
    label: 'Automóvel',
    value: 'CAR',
    icon: AutoParticularesIcon
  },
  {
    label: 'Saúde',
    value: 'HEALTH',
    icon: SaudeParticularesIcon
  },
  {
    label: 'Vida',
    value: 'LIFE',
    icon: VidaProtecaoIcon
  },
  {
    label: 'Vida Crédito',
    value: 'MORTGAGE',
    icon: VidaCreditoHabitacaoIcon
  },
  {
    label: 'Multirriscos Habitação',
    value: 'HOME',
    icon: MultiRiscosHabitacaoIcon
  },
  {
    label: 'Acidentes de Trabalho',
    value: 'WORKACCIDENT',
    icon: WorkAccidentIcon
  },
  {
    label: 'Acidentes Pessoais',
    value: 'PERSONALACCIDENT',
    icon: AcidentesPessoaisIcon
  },
  {
    label: 'Empregada Doméstica',
    value: 'HOUSEKEEPER',
    icon: HousekeeperIcon
  },
  {
    label: 'Animais Domésticos',
    value: 'PET',
    icon: PetsIcon
  },
  {
    label: 'Outro',
    value: 'OTHER',
    icon: QuestionIcon
  },
];

export const monthsList = [
  {
    label: 'Janeiro',
    value: 'JANUARY'
  },
  {
    label: 'Fevereiro',
    value: 'FEBRUARY'
  },
  {
    label: 'Março',
    value: 'MARCH'
  },
  {
    label: 'Abril',
    value: 'APRIL'
  },
  {
    label: 'Maio',
    value: 'MAY'
  },
  {
    label: 'Junho',
    value: 'JUNE'
  },
  {
    label: 'Julho',
    value: 'JULY'
  },
  {
    label: 'Agosto',
    value: 'AUGUST'
  },
  {
    label: 'Setembro',
    value: 'SEPTEMBER'
  },
  {
    label: 'Outubro',
    value: 'OCTOBER'
  },
  {
    label: 'Novembro',
    value: 'NOVEMBER'
  },
  {
    label: 'Dezembro',
    value: 'DECEMBER'
  },
];

export const insurersList = [
  {
    label: 'Abarca',
    value: 'ABARCA'
  },
  {
    label: 'ACE',
    value: 'ACE'
  },
  {
    label: 'ACP',
    value: 'ACP'
  },
  {
    label: 'Aegon',
    value: 'AEGON'
  },
  {
    label: 'Ageas',
    value: 'AGEAS'
  },
  {
    label: 'AIG',
    value: 'AIG'
  },
  {
    label: 'Allianz',
    value: 'ALLIANZ'
  },
  {
    label: 'April',
    value: 'APRIL'
  },
  {
    label: 'ARAG',
    value: 'ARAG'
  },
  {
    label: 'Asisa',
    value: 'ASISA'
  },
  {
    label: 'Atradius',
    value: 'ATRADIUS'
  },
  {
    label: 'AWP',
    value: 'AWP'
  },
  {
    label: 'AXA',
    value: 'AXA'
  },
  {
    label: 'Bankinter',
    value: 'BANKINTER'
  },
  {
    label: 'BBVA',
    value: 'BBVA'
  },
  {
    label: 'BMG Seguros',
    value: 'BMG SEGUROS'
  },
  {
    label: 'BPI',
    value: 'BPI'
  },
  {
    label: 'Caravela',
    value: 'CARAVELA'
  },
  {
    label: 'Cardif',
    value: 'CARDIF'
  },
  {
    label: 'Cesce',
    value: 'CESCE'
  },
  {
    label: 'CFA',
    value: 'CFA'
  },
  {
    label: 'Chubb European',
    value: 'CHUBBEUROPEAN'
  },
  {
    label: 'Continente',
    value: 'CONTINENTE'
  },
  {
    label: 'COSEC',
    value: 'COSEC'
  },
  {
    label: 'CPR',
    value: 'CPR'
  },
  {
    label: 'Crédito Agrícola',
    value: 'CREDITOAGRICOLA'
  },
  {
    label: 'Divina',
    value: 'DIVINA'
  },
  {
    label: 'Domestic & General',
    value: 'DOMESTIC & GENERAL'
  },
  {
    label: 'Espanasa',
    value: 'ESPANASA'
  },
  {
    label: 'Europ Assistance',
    value: 'EUROPASSISTANCE'
  },
  {
    label: 'Fidelidade',
    value: 'FIDELIDADE'
  },
  {
    label: 'GamaLife',
    value: 'GAMALIFE'
  },
  {
    label: 'Genesis',
    value: 'GENESIS'
  },
  {
    label: 'GNB',
    value: 'GNB'
  },
  {
    label: 'Helvetia',
    value: 'HELVETIA'
  },
  {
    label: 'Hiscox',
    value: 'HISCOX'
  },
  {
    label: 'Innovarisk',
    value: 'INNOVARISK'
  },
  {
    label: 'Inter',
    value: 'INTER'
  },
  {
    label: 'Intermundial',
    value: 'INTERMUNDIAL'
  },
  {
    label: 'Lloyd',
    value: 'LLOYD'
  },
  {
    label: 'Logo',
    value: 'LOGO'
  },
  {
    label: 'London General',
    value: 'LONDONGENERAL'
  },
  {
    label: 'Lusitania',
    value: 'LUSITANIA'
  },
  {
    label: 'Lusitania Vida',
    value: 'LUSITANIA VIDA'
  },
  {
    label: 'Mapfre',
    value: 'MAPFRE'
  },
  {
    label: 'Medis',
    value: 'MEDIS'
  },
  {
    label: 'MetLife',
    value: 'METLIFE'
  },
  {
    label: 'MGEN',
    value: 'MGEN'
  },
  {
    label: 'Mudum',
    value: 'MUDUM'
  },
  {
    label: 'Multicare',
    value: 'MULTICARE'
  },
  {
    label: 'Mútua de Pescadores',
    value: 'MUTUAPESCADORES'
  },
  {
    label: 'N Seguros',
    value: 'NSEGUROS'
  },
  {
    label: 'Ocidental',
    value: 'OCIDENTAL'
  },
  {
    label: 'OK! Seguros',
    value: 'OKSEGUROS'
  },
  {
    label: 'OK Tele Seguros',
    value: 'OKTELESEGUROS'
  },
  {
    label: 'Planicare',
    value: 'PLANICARE'
  },
  {
    label: 'Popular',
    value: 'POPULAR'
  },
  {
    label: 'Previsión Sanitaria',
    value: 'PREVISIONSANITARIA'
  },
  {
    label: 'Prévoir',
    value: 'PREVOIR'
  },
  {
    label: 'Real Vida',
    value: 'REALVIDA'
  },
  {
    label: 'RNA',
    value: 'RNA'
  },
  {
    label: 'Saúde Prime',
    value: 'SAUDEPRIME'
  },
  {
    label: 'Seguradora Sunidas',
    value: 'SEGURADORASUNIDAS'
  },
  {
    label: 'Seguro Direto',
    value: 'SEGURODIRETO'
  },
  {
    label: "Society of Lloyd's",
    value: 'SOCIETYLLOYDS'
  },
  {
    label: 'SPB Ibérica',
    value: 'SPBIBERICA'
  },
  {
    label: 'Totta',
    value: 'TOTTA'
  },
  {
    label: 'Generali Tranquilidade',
    value: 'TRANQUILIDADE'
  },
  {
    label: 'UNA',
    value: 'UNA'
  },
  {
    label: 'Via Directa',
    value: 'VIADIRECTA'
  },
  {
    label: 'Victoria',
    value: 'VICTORIA'
  },
  {
    label: 'Zurich',
    value: 'ZURICH'
  },
  {
    label: 'Outra',
    value: 'OTHER'
  }
];
